import {useCallback, useEffect} from 'react';
import {ErrorArea} from '../../design-system/organisms/ErrorArea/ErrorArea';
import {useLogin} from '../../user/useLogin.hook';
import {t} from '../getTranslations';
import {requestContext} from '../requestContext';
import {IsLoginCheckerProps} from './IsLoginCheckerProps';

/**
 * children 이 로그인이 필요한 컴포넌트인 경우 사용하는 체커
 */
export function IsLoginChecker({children}: IsLoginCheckerProps) {
  const {isMobile, isWebView} = requestContext.requestInfo?.display ?? false;
  const {isLogin, doLogin} = useLogin();
  const onClickLogin = useCallback(() => {
    doLogin();
  }, [doLogin]);

  useEffect(() => {
    if (isWebView && !isLogin) {
      location.assign('kakaopage://session/expired');
    }
  }, [isLogin, isWebView]);

  if (!isLogin) {
    if (isWebView) {
      return null;
    }
    return (
      <ErrorArea isMobile={isMobile}>
        <ErrorArea.Title>
          {t('alert_message_for_not_logged_in_user')}
        </ErrorArea.Title>
        <ErrorArea.LabelButton onClick={onClickLogin}>
          {t('common_login_button')}
        </ErrorArea.LabelButton>
      </ErrorArea>
    );
  }
  if (!children) {
    return null;
  }
  return <>{children}</>;
}
